import { Provider } from '@angular/core';
import { CompanyCollectorRepository } from '@domain/company-collector/repositories/company-collector.repository';
import { CompanyCollectorRepositoryService } from '../repositories/company-collector.service';
import { CompanyCollectorMapper } from '@domain/company-collector/mappers/company-collector.mapper';

export const CompanyCollectorProvider: Provider[] = [
  {
    provide: CompanyCollectorRepository,
    useClass: CompanyCollectorRepositoryService,
  },
  CompanyCollectorMapper,
];
